import React from 'react'
import cx from 'classnames'

import cm from './Textarea.module.css'

export const Textarea = React.forwardRef<HTMLTextAreaElement, React.ComponentProps<'textarea'>>(
  ({ className, ...props }, ref) => {
    return (
      <textarea {...props} ref={ref} className={cx('text-subheading', cm.textarea, className)} />
    )
  },
)
